// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, TilingSprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'Rectangle',
        x: 0,
        y: 0,
        width: 10000,
        height: 10000
      },
      parent: ''
    },
    {
      id: '549ad031-9985-4d10-a69a-59263f417c37',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'bg',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6fc27cff-ea14-46ac-a696-61ca326fbdd3',
      type: 'Container',
      name: 'uiContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1db284e3-a7c3-4e12-bc57-5c3e9b4db388',
      type: 'Container',
      name: 'enemyBoardSlot',
      className: 'centerH',
      x: 385,
      y: 144,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: '68cd5c63-a258-4ef8-a644-e25662278bf6',
      type: 'Container',
      name: 'boardSlot',
      className: 'centerH',
      x: 0,
      y: 916,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: '6df5fba0-a34d-4dc4-b486-b1ae67eb3892',
      type: 'Container',
      name: 'bottomContainer',
      className: 'bottom',
      x: 0,
      y: 1280,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: '18a697f7-e082-4ce3-9ac9-894462f5edc1',
      type: 'Container',
      name: 'rightContainer',
      className: 'right',
      x: 780,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: '508e7660-4c19-4518-b972-c266b968b4fc',
      type: 'Container',
      name: 'underTopBarSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3',
      interactiveChildren: false
    },
    {
      id: '60184df1-276d-430e-b429-4e1e82d872ed',
      type: 'Container',
      name: 'topBarContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: 'd778e0bd-9b98-46ce-a913-dc3d2514ad3b',
      type: 'Container',
      name: 'scoreOverlayContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: 'a805dcca-139c-4eb4-bfff-dddc5f669cfd',
      type: 'Container',
      name: 'collectionTraySlot',
      className: '',
      x: 0,
      y: 200,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: 'e2a7c5f7-587a-4cdf-914d-2ba9ae48cfb0',
      type: 'Container',
      name: 'topBarSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: 'a1779e2c-5bf5-4db7-8d01-744d75d09b19',
      type: 'Container',
      name: 'boosterUseOverlaySlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: 'e47d9949-c61b-4e68-a794-770b650bc4a0',
      type: 'Container',
      name: 'overlayContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: '6393dfcd-dd35-4a1f-b79e-8950db7b224f',
      type: 'Container',
      name: 'winParticleContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6fc27cff-ea14-46ac-a696-61ca326fbdd3'
    },
    {
      id: '1891e7d7-49f5-42ed-a491-46ab5063bfb6',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: 'bottomBar',
      className: 'fullWidth',
      x: 0,
      y: 130,
      anchor: {
        x: 0,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'bottomBar',
      parent: '6df5fba0-a34d-4dc4-b486-b1ae67eb3892',
      stateByName: {
        horizontal: {
          visible: false
        }
      }
    },
    {
      id: '95861b6c-5117-4624-80e0-b687df19c8f5',
      type: 'Container',
      name: 'trayContainer',
      className: 'centerH',
      x: 390,
      y: -338,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6df5fba0-a34d-4dc4-b486-b1ae67eb3892',
      stateByName: {
        horizontal: {
          y: -189
        }
      }
    },
    {
      id: '20794385-77bb-4fa8-aeeb-d0d557d77184',
      type: 'Container',
      name: 'portraitBoosterSlot',
      className: 'centerH',
      x: 390,
      y: -90,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 50,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6df5fba0-a34d-4dc4-b486-b1ae67eb3892'
    },
    {
      id: 'ac3bb19a-65e3-420e-9901-920e379d0577',
      type: 'Container',
      name: 'horizontalBoosterContainer',
      className: 'centerV',
      x: 0,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '18a697f7-e082-4ce3-9ac9-894462f5edc1'
    },
    {
      id: '899fc1b7-e667-4b96-a1f9-9d8271c476f3',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: 'topBar',
      className: 'fullWidth',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: '60184df1-276d-430e-b429-4e1e82d872ed',
      stateByName: {
        versus: {
          visible: false
        }
      }
    },
    {
      id: '194cf2fb-e675-4770-b430-fee1c57d7dc5',
      type: 'Sprite',
      name: 'hexTray',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'bottomBox',
      parent: '95861b6c-5117-4624-80e0-b687df19c8f5',
      stateByName: {
        horizontal: {
          texture: 'Hexagons_Box_Landscape'
        }
      }
    },
    {
      id: 'c3552c1d-0a69-421f-b2f7-49655da5e071',
      type: 'Container',
      name: 'traySlot',
      className: '',
      x: 0,
      y: 84,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '95861b6c-5117-4624-80e0-b687df19c8f5',
      stateByName: {
        horizontal: {
          y: 112
        }
      }
    },
    {
      id: 'c245572b-2feb-41cf-867e-ab59066a6667',
      type: 'Sprite',
      name: '',
      className: 'helpButton',
      x: 384,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Help_Button',
      parent: '20794385-77bb-4fa8-aeeb-d0d557d77184',
      stateByName: {
        horizontal: {
          visible: false
        },
        versus: {
          visible: false
        }
      }
    },
    {
      id: '801d2ed1-fef5-4ee8-a4c2-472955db0813',
      type: 'Sprite',
      name: 'horizontalBoosterBackground',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Box_Landscape',
      parent: 'ac3bb19a-65e3-420e-9901-920e379d0577',
      stateByName: {
        horizontal: {
          visible: true
        }
      }
    },
    {
      id: '2c3fa17e-f585-425b-8ae9-4807461e988e',
      type: 'Container',
      name: 'horizontalBoosterSlot',
      className: '',
      x: -136,
      y: -52,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ac3bb19a-65e3-420e-9901-920e379d0577'
    },
    {
      id: 'b8e4921f-0c07-4db7-a76d-c2f3d7239bdd',
      type: 'Sprite',
      name: '',
      className: 'helpButton',
      x: -136,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Help_Button',
      parent: 'ac3bb19a-65e3-420e-9901-920e379d0577',
      stateByName: {
        horizontal: {
          visible: true
        },
        versus: {
          visible: false
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  stateNames: [
    'horizontal',
    'versus'
  ],
  handleResize: false
} as const;

export class GameSceneLayout {
  static raw = raw;
  root!: Container;
  background!: Sprite;
  uiContainer!: Container;
  enemyBoardSlot!: Container;
  boardSlot!: Container;
  bottomContainer!: Container;
  rightContainer!: Container;
  underTopBarSlot!: Container;
  topBarContainer!: Container;
  scoreOverlayContainer!: Container;
  collectionTraySlot!: Container;
  topBarSlot!: Container;
  boosterUseOverlaySlot!: Container;
  overlayContainer!: Container;
  winParticleContainer!: Container;
  bottomBar!: TilingSprite;
  trayContainer!: Container;
  portraitBoosterSlot!: Container;
  horizontalBoosterContainer!: Container;
  topBar!: TilingSprite;
  hexTray!: Sprite;
  traySlot!: Container;
  horizontalBoosterBackground!: Sprite;
  horizontalBoosterSlot!: Container;
  centerH!: (Container)[];
  bottom!: (Container)[];
  right!: (Container)[];
  fullWidth!: (TilingSprite)[];
  centerV!: (Container)[];
  helpButton!: (Sprite)[];
  StateName!: 'horizontal' | 'versus';

  constructor() {
    populate(this, raw);
  }
}
